module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "poiActive.eb7dfd82.svg";